export default __webpack_public_path__ + "static/media/sustainability-report.e3a44469.png";